import {MutableRefObject, useEffect, useRef} from "react";

/**
 * Custom search hook, we pass search callback action and search value,
 * we fire and clear timeouts for each searchDelay
 *
 * @param {Function} searchCb
 * @param {string} searchValue
 */
const useSearch = (searchCb: Function, searchValue: string) => {
    const searchDelay: number = 400;
    const isFirstRender: MutableRefObject<boolean> = useRef(true);

    useEffect(() => {
        // prevent firing search on first render of component
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return undefined;
        }

        const timer: ReturnType<typeof setTimeout> = setTimeout(
            (): void => (searchCb(searchValue)), searchDelay,
        );
        return (): void => clearTimeout(timer);
    }, [searchCb, searchValue]);
};

export default useSearch;
